import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { FileTypeEnum } from "src/app/enums/fileType.enum";
import { isTrustedFileUrl } from "src/app/shared/utils/file-link.util";
import { ReportService } from "src/app/services/report.service";
import { ToastService } from "src/app/services/toast.service";

@Component({
  standalone: false,
    selector: "app-report-view",
    templateUrl: "./report-view.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./report-view.component.scss"],
})
export class ReportViewComponent implements OnInit {
    reportId: string;
    reportUrl: SafeResourceUrl;
    isLoading: boolean;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private reportService: ReportService,
        private toastService: ToastService,
    ) {}

    ngOnInit(): void {
        this.reportId = this.route.snapshot.paramMap.get("id");
        this.loadReport();
    }

    loadReport(): void {
        this.isLoading = true;
        this.reportService.getById(this.reportId).subscribe({
            next: (report) => {
                let url = report?.reportUrl;

                if (
                    report?.fileAttachments &&
                    report.fileAttachments.length > 0
                ) {
                    const pdfAttachment =
                        report.fileAttachments.find(
                            (f) => f.fileType === FileTypeEnum.Pdf,
                        ) || report.fileAttachments[0];
                    if (pdfAttachment && pdfAttachment.url) {
                        url = pdfAttachment.url;
                    }
                }

                if (isTrustedFileUrl(url)) {
                    this.reportUrl =
                        this.sanitizer.bypassSecurityTrustResourceUrl(url);
                } else {
                    this.toastService.displayErrorMessage(
                        "Report file not found. Please contact an administrator.",
                        true,
                    );
                }
                this.isLoading = false;
            },
            error: (error) => {
                this.toastService.showError(error);
                this.isLoading = false;
            },
        });
    }
}
